
import {Vue, Component} from 'vue-property-decorator';
import {GOOGLE_MAPS_KEY, nil} from '@/common';
import {Sync} from 'vuex-pathify';

@Component({
    components: {
    },
})
export default class LocationMixin extends Vue {
    private autocomplete!: any;
    @Sync('booking/formattedAddress') public formattedAddress?: string;
    @Sync('booking/latitude') public latitude!: number;
    @Sync('booking/longitude') public longitude!: number;

    public whiteListedCounties = [
            {county:'bronx', state:'NY'},
            {county:'kings', state:'NY'},
            {county:'queens', state:'NY'},
            {county:'staten island', state:'NY'},
            {county:'nassau', state:'NY'},
            {county:'suffolk', state:'NY'},
            {county:'new york', state:'NY'},
            {county:'manhattan', state:'NY'},
            {county:'westchester', state:'NY'},
            {county:'rockland', state:'NY'},
            {county:'putnam', state:'NY'},
            {county:'orange', state:'NY'},
            {county:'bergen', state:'NJ'},
            {county:'essex', state:'NJ'},
            {county:'morris', state:'NJ'},
            {county:'passaic', state:'NJ'},
            {county:'atlantic', state:'NJ'},
            {county:'warren', state:'NJ'},
            {county:'sommerset', state:'NJ'},
            {county:'hudson', state:'NJ'},
            {county:'fairfield', state:'CT'},
            {county:'salt lake', state:'UT'},
            {county:'davis', state:'UT'},
            {county:'washington', state:'UT'},
            {county:'las vegas', state:'NV'},
            {county:'los angeles', state:'CA'},
        ];
    public whiteListedCities = [
        {state:'NV',city:'las vegas'},
        {state:'NJ',city:'atlantic city'},
        {city:'los angeles', state:'CA'},
        {city:'chicago', state:'IL'},
    ];
    public extractLocation(location){
        const [city] = location.address_components.filter(x=>x.types.indexOf("locality") > -1).map(x=>x.short_name);
        const [state] = location.address_components.filter(x=>x.types.indexOf("administrative_area_level_1") > -1).map(x=>x.short_name);
        const [county] = location.address_components.filter(x=>x.short_name.indexOf(" County") > -1).map(x=>x.short_name);
        return {
            state,
            county,
            city,
        }
    }
    public isLocationWhiteListed(locationObject){
        if(nil(locationObject.state)){
            return false;
        }
        //first check if we service the entire city
        let [cityMatch] = this.whiteListedCities.filter(x=>
            x.state.toUpperCase() === locationObject.state.toUpperCase()
            && locationObject.city.toLowerCase().indexOf(x.city.toLowerCase()) > -1
        );
        if(!nil(cityMatch,true)){
            return true;
        }
        //then check the counties, otherwise it will fail.
        let [countyMatch] = this.whiteListedCounties.filter(x=>
            x.state.toUpperCase() === locationObject.state.toUpperCase()
            && locationObject.county.toLowerCase().indexOf(x.county.toLowerCase()) > -1
        );
        return !nil(countyMatch, true);
    }
    public setupAddressInputs() {
        const el = document.querySelector('#googleplacesinput') as HTMLInputElement;
        if (!nil(el)) {
            this.autocomplete = new google.maps.places.Autocomplete(el, {types: ['address']});
            this.autocomplete.addListener('place_changed', (x) => {
                const location = this.autocomplete.getPlace();
                const extractedLocation = this.extractLocation(location);
                const isWhiteListed = this.isLocationWhiteListed(extractedLocation);
                if(isWhiteListed) {
                    this.formattedAddress = location.formatted_address;
                    if (!nil(location.geometry)) {
                        this.latitude = location.geometry.location.lat();
                        this.longitude = location.geometry.location.lng();
                    } else {
                        alert('Error getting location');
                    }
                } else {
                    console.log('emitting location not supported')
                    this.$bus.$emit('location_not_supported', {location, extractedLocation});
                }
            });
        }
    }
}
